import { WelfarePlan, useAuthStore } from '@tundr/auth';
import type { RouteRecordRaw } from 'vue-router';
import AppRouter from '@modules/app/AppRouter.vue';
import { dashboardRoutesConfig } from '@modules/app/dashboard/routes/dashboard-routes.config.ts';
import { depositRoutesConfig } from '@modules/app/deposit/routes/deposit-routes.config.ts';
import {
  employeeRoutesConfig,
  subscriptionRoutesConfig,
} from '@modules/app/employee/routes/employee-routes.config.ts';
import { flexCreditsRoutesConfig } from '@modules/app/flex-credits/routes/flex-credits-routes.config.ts';
import { fringeThresholdsRoutesConfig } from '@modules/app/fringe-thresholds/routes/fringe-thresholds-routes.config.ts';
import { hrRoutesConfig } from '@modules/app/hr/routes/hr-routes.config.ts';
import { mealVouchersRoutesConfig } from '@modules/app/meal-vouchers/routes/meal-vouchers-routes.config.ts';
import { officesRoutesConfig } from '@modules/app/office/routes/office-routes-config';
import { tracciatoBustaPagaReportsRoutesConfig } from '@modules/app/reports/routes/TracciatoBustaPaga/tracciato-busta-paga-reports-routes.config.ts';
import { voucherReportsRoutesConfig } from '@modules/app/reports/routes/Voucher/voucher-reports-routes.config.ts';
import { authRoutesConfig } from '@modules/auth/routes/auth-routes.config';
import { sessionInitGuard } from '../lifecycle-hooks/session-init-guard';
import { cardRoutesConfig } from './../../modules/app/card/routes/card-routes-config';
import { creditsRoutesConfig } from './../../modules/app/credits/routes/credits-routes.config';
import { appRoutesDictionary } from './app-routes.dictionary.ts';

export const routes: RouteRecordRaw[] = [
  {
    ...appRoutesDictionary.root.notFound,
    component: () => import('@shared/components/NotFoundPage/NotFoundPage.vue'),
  },
  {
    ...appRoutesDictionary.root.root,
    redirect: appRoutesDictionary.auth.root,
  },
  authRoutesConfig,
  {
    ...appRoutesDictionary.root.app,
    component: AppRouter,
    children: [
      hrRoutesConfig,
      employeeRoutesConfig,
      subscriptionRoutesConfig,
      officesRoutesConfig,
      fringeThresholdsRoutesConfig,
      creditsRoutesConfig,
      flexCreditsRoutesConfig,
      mealVouchersRoutesConfig,
      cardRoutesConfig,
      voucherReportsRoutesConfig,
      tracciatoBustaPagaReportsRoutesConfig,
      depositRoutesConfig,
      dashboardRoutesConfig,
      {
        ...appRoutesDictionary.root.forbidden,
        component: () =>
          import('@shared/components/ForbiddenPage/ForbiddenPage.vue'),
      },
    ],
    redirect: () => {
      const authStore = useAuthStore();
      const isStandardPlan =
        authStore.currentWelfarePlan === WelfarePlan.STANDARD;

      if (isStandardPlan) {
        return { name: appRoutesDictionary.dashboard.root.name };
      }

      return { name: appRoutesDictionary.employees.root.name };
    },
    beforeEnter: sessionInitGuard,
  },
];
